module.exports = __webpack_public_path__ + "static/media/defaultTransferResult.754580bd.png";